<template>
  <div class="contact-card">
    <div class="bubble">
      <UiComponentIcon type="message-circle" />
    </div>
    <UiComponentParagraph class="title">
      <slot name="title" />
    </UiComponentParagraph>
    <UiComponentParagraph class="info">
      <slot name="paragraph" />
    </UiComponentParagraph>
    <AtomButton
      size="l"
      type="secondary"
      to="mailto:hello@livestorm.co"
    >
      <slot name="call-to-action" />
    </AtomButton>
  </div>
</template>

<style lang="postcss" scoped>
.contact-card {
  @apply hidden flex-col items-center self-center bg-white p-10 rounded-4xl shadow-light2;

  @screen xl {
    @apply flex;
  }

  .bubble {
    @apply flex justify-center items-center h-20 w-20 bg-livestorm-blue-100 rounded-full;

    i {
      @apply text-livestorm-blue-600 text-2xl;
    }
  }

  .title {
    @apply mt-6 text-winter-green-900;
  }

  .info {
    @apply mt-4 text-grey-blue-700 text-center;
  }

  .button {
    @apply mt-4;
  }
}
</style>
